var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditRow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5485 4C16.0722 4 16.5743 4.20911 16.9409 4.57867L19.4214 7.0591C19.7907 7.4284 19.9981 7.92928 19.9981 8.45155C19.9981 8.97381 19.7907 9.47469 19.4214 9.84399L10.3652 18.8973C9.80651 19.5418 9.0145 19.9378 8.10716 20H3.99996V19.2001L4.00256 15.8285C4.0707 14.985 4.46284 14.2007 5.06104 13.6736L14.1551 4.57964C14.5239 4.20864 15.0254 4 15.5485 4ZM8.05058 18.4022C8.47791 18.3719 8.87569 18.173 9.19509 17.8077L15.244 11.7588L12.2409 8.75549L6.1565 14.8384C5.83241 15.125 5.63192 15.526 5.59968 15.8929V18.4007L8.05058 18.4022ZM13.3722 7.62439L16.3753 10.6275L18.29 8.71274C18.3593 8.64347 18.3982 8.54951 18.3982 8.45154C18.3982 8.35357 18.3593 8.25961 18.29 8.19033L15.8074 5.70768C15.7389 5.63864 15.6457 5.59981 15.5484 5.59981C15.4511 5.59981 15.3579 5.63864 15.2894 5.70768L13.3722 7.62439Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRow);
export default __webpack_public_path__ + "static/media/editRow.c2fbb11b.svg";
export { ForwardRef as ReactComponent };